<template>
    <div style="text-align: center;">
        <h4>เงินภาษี</h4>
        <br />
        <div class="row form-group">
            <b-col sm="4" class="col-sm-4 text-right">
                <label>เงินเดือนระหว่าง</label>
            </b-col>
            <b-col sm="5" class="col-sm-5">
                <input v-model.number="form.salary_min"
                       type="number" class="form-control"/>
            </b-col>
            <b-col sm="2" class="col-sm-2 text-left">
                <label>บาท</label>
            </b-col>
        </div>
        <div class="row form-group">
            <b-col sm="4" class="col-sm-4 text-right">
                <label>ถึง</label>
            </b-col>
            <b-col sm="5" class="col-sm-5">
                <input v-model.number="form.salary_max"
                       type="number" class="form-control"/>
            </b-col>
            <b-col sm="2" class="col-sm-2 text-left">
                <label>บาท</label>
            </b-col>
        </div>

        <div class="row form-group">
            <b-col sm="4" class="col-sm-4 text-right">
                <label>เงินภาษี</label>
            </b-col>
            <b-col sm="5" class="col-sm-5">
                <input v-model.number="form.amount"
                       type="number" class="form-control"/>
            </b-col>
            <b-col sm="3" class="col-sm-3 text-left">
                <select class="form-control mr-sm-2"
                        v-model="form.unit_id">
                    <option value="1">บาท</option>
                    <option value="2">%</option>
                </select>
            </b-col>
        </div>
        <button type="button"
                @click="submitData"
                class="btn btn-success mt-2">
            บันทึก
        </button>
        &nbsp;&nbsp;
        <button
            @click="cancelData"
            type="button"
            class="btn btn-outline-secondary mt-2">
            ยกเลิก
        </button>
    </div>
</template>

<script>
    import {mapState} from "vuex";

    export default {
        name: "RateTaxPersonModal",
        computed:{
            ...mapState({
                form:state=>{
                    return state.SocialSecurity.form_tax;
                },
            }),
        },
        methods:{
          submitData(){
              this.$emit("submit",this.form)
          },
            cancelData(){
                this.$emit("submit",false)
            }
        },
    }
</script>

<style scoped>

</style>
